import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, MessageCircle } from "lucide-react";
import { SHOP } from "@/lib/api";

export default function Footer() {
  return (
    <footer className="bg-black text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img src="/logo.webp" alt="Appleman Tech Repair logo" className="h-14 w-14 object-contain bg-white p-1" />
              <span className="font-display font-black uppercase leading-none">Appleman<br /><span className="text-xs tracking-[0.3em] text-neutral-400">Tech Repair</span></span>
            </div>
            <p className="text-neutral-400 text-sm leading-relaxed max-w-xs">
              Independent phone, tablet and console repair in Hyde, Tameside. Fast turnaround, honest pricing, warranty on every repair. Repairs by online booking only.
            </p>
          </div>
          <div>
            <h4 className="font-display font-bold uppercase tracking-widest text-sm mb-6 text-accent">Visit the shop</h4>
            <ul className="space-y-4 text-sm text-neutral-300">
              <li className="flex gap-3"><MapPin className="h-4 w-4 mt-0.5 shrink-0 text-accent" /> {SHOP.address}</li>
              <li className="flex gap-3"><Phone className="h-4 w-4 mt-0.5 shrink-0 text-accent" /> <a href={SHOP.phoneHref} className="hover:text-white" data-testid="footer-phone-link">{SHOP.phone}</a></li>
              <li className="flex gap-3"><MessageCircle className="h-4 w-4 mt-0.5 shrink-0 text-accent" /> <a href={SHOP.whatsapp} target="_blank" rel="noopener noreferrer" className="hover:text-white" data-testid="footer-whatsapp-link">WhatsApp {SHOP.whatsappDisplay}</a></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-bold uppercase tracking-widest text-sm mb-6 text-accent"><Clock className="inline h-4 w-4 mr-2 -mt-1" />Opening hours</h4>
            <ul className="space-y-2 text-sm text-neutral-300">
              {SHOP.hours.map((h) => (
                <li key={h.day} className="flex justify-between max-w-xs border-b border-neutral-800 pb-2">
                  <span>{h.day}</span>
                  <span className={h.time === "Closed" ? "text-neutral-600" : ""}>{h.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="font-display font-black uppercase tracking-tighter leading-none text-[16vw] md:text-[10vw] text-neutral-900 select-none text-center" aria-hidden="true">
          Appleman
        </div>
        <div className="border-t border-neutral-800 mt-8 pt-8 flex flex-col sm:flex-row justify-between gap-4 text-xs text-neutral-500 uppercase tracking-widest">
          <span>© {new Date().getFullYear()} Appleman Tech Repair — Tameside</span>
          <div className="flex gap-6">
            <Link to="/book" className="hover:text-white" data-testid="footer-book-link">Book a repair</Link>
            <Link to="/sell" className="hover:text-white" data-testid="footer-sell-link">Sell my device</Link>
            <a href="https://www.facebook.com/Applemanrepairs/" target="_blank" rel="noopener noreferrer" className="hover:text-white" data-testid="footer-facebook-link">Facebook</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
